import React, { useCallback, useEffect, useState } from "react";
import Table from "../../../Table";
import Modal from "../../../modal";
import { FaAngleDown } from "react-icons/fa6";
import { Dropdown, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  GetPurchase,
  UpdatePurchase,
} from "../../../../redux/Transaction/action";
import dayjs from "dayjs";
import useInfiniteScroll from "../../../Hooks/useInfiniteScroll";
import NoData from "../../../noData";
import { MdOutlinePending } from "react-icons/md";
import SelectInput from "../../../selectInput";
import { getPayment } from "../../../../redux/payment/action";
import { generatePopup } from "../../../../utility/popup";

const validatePendingForm = (data) => {
  const errors = {};
  if (!data.pendingPaymentMethod)
    errors.pendingPaymentMethod = "Payment method is required";
  return errors;
};

const PendingTable = ({ searchValue }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [paymentPage, setPaymentPage] = useState(20);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenPending, setIsOpenPending] = useState(false);
  const [loading, setLoading] = useState(false);
  const [purchasesData, setPurchasesData] = useState();
  const [selectedSale, setSelectedSale] = useState(null); // State for selected sale
  const [errors, setErrors] = useState({});
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    type: true,
  });
  const [hasMoreData, setHasMoreData] = useState(true);
  const [pendingPaymentMethod, setPendingPaymentMethod] = useState(null); // State for pending payment method

  const purchaseData = useSelector((state) => state?.Sale?.purchaseData?.data);

  const getPaymentData = useSelector(
    (state) => state?.Payment?.getPayment?.data
  );

  const paymentOption = getPaymentData?.map((e) => {
    return {
      lable: e?.paymentmethod,
      value: e?._id,
    };
  });

  const openModal = (purchase) => {
    setSelectedSale(purchase);
    setIsOpen(true);
  };
  const closeModal = () => {
    setSelectedSale(null); // Reset selected sale
    setIsOpen(false);
  };

  const openPendingModal = (purchase) => {
    setSelectedSale(purchase);
    setIsOpenPending(true);
  };
  const closePendingModal = () => {
    setSelectedSale(null); // Reset selected sale
    setIsOpenPending(false);
  };

  const handleApproval = async () => {
    let obj = {
      date: dayjs(selectedSale?.date).format("DD/MM/YYYY").toString(),
      title: selectedSale?.title,
      vendorselection: selectedSale?.vendorselection?._id,
      vatamount: selectedSale?.vatamount,
      nonvatamount: selectedSale?.nonvatamount,
      paymentmethod: selectedSale?.paymentmethod?._id,
      description: selectedSale?.description,
      status: selectedSale?.status ? false : true,
      totalamount: selectedSale?.vatamount + selectedSale?.nonvatamount,
    };
    await dispatch(UpdatePurchase({ id: selectedSale?._id, data: obj })).then(
      (res) => {
        if (res?.status === 200) {
          dispatch(
            GetPurchase({
              page: filter?.page,
              limit: filter?.limit,
              storeName: searchValue,
              type: filter?.type,
            })
          );
        } else if (res?.data?.status === 401) {
          navigate("/");
        } else if (res?.data?.status === 400) {
          generatePopup("error", res?.data?.message);
        }
      }
    );
    closeModal();
  };

  const handlePendingPayment = async () => {
    const errors = validatePendingForm({
      pendingPaymentMethod: pendingPaymentMethod,
    });

    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }

    let obj = {
      date: dayjs(selectedSale?.date).format("DD/MM/YYYY").toString(),
      title: selectedSale?.title,
      vendorselection: selectedSale?.vendorselection?._id,
      vatamount: selectedSale?.vatamount,
      nonvatamount: selectedSale?.nonvatamount,
      paymentmethod: selectedSale?.paymentmethod?._id,
      description: selectedSale?.description,
      status: selectedSale?.status,
      pendingpaymentmethod: pendingPaymentMethod,
      pendingpayment: false, // Set the type to false
    };

    setLoading(true);
    await dispatch(UpdatePurchase({ id: selectedSale?._id, data: obj })).then(
      (res) => {
        if (res?.status === 200) {
          dispatch(
            GetPurchase({
              page: filter?.page,
              limit: filter?.limit,
              storeName: searchValue,
              type: filter?.type,
            })
          );
          setLoading(false); // Close modal on success
        } else if (res?.data?.status === 401) {
          setLoading(false);
          navigate("/");
        } else if (res?.data?.status === 400) {
          generatePopup("error", res?.data?.message);
        }
        closePendingModal();
      }
    );

    setLoading(false);
  };

  const tableHeading = {
    no: <div className="ml-5 text-center">No.</div>,
    store: <div className="px-2 text-left">Store</div>,
    date: <div className="text-center">Date</div>,
    title: <div className="px-2">Title</div>,
    description: <div className="px-2">Description</div>,
    vendorSelection: <div className="text-center">Vendor Selection</div>,
    nonvatamount: <div className="text-center">Non Vat Amount</div>,
    vatamount: <div className="text-center">Vat Amount</div>,
    paymentMethod: <div className="text-center">Payment Method</div>,
    status: <div className="text-center">Status</div>,
    pendingpayment: <div className="mr-5 text-center">Pending Payment</div>,
  };

  const headData = Object.values(tableHeading);
  const bodyData = purchasesData?.map((e, index) => {
    const status = e?.status ? "Approved" : "Pending";
    const items = [
      {
        label: e?.status ? "Pending" : "Approve",
        key: e?.status ? "pending" : "approve",
        icon: <img src="/images/checkCircle.svg" alt="" />,
      },
    ];
    const menuProps = {
      items,
      onClick: () => openModal(e),
    };

    return {
      no: <div className="ml-5 text-center">{index + 1}</div>,
      store: (
        <div className="px-2 text-left">
          {e?.createdBy?.user?.name || e?.createdBy?.store?.name}
        </div>
      ),
      date: (
        <div className="text-center">{dayjs(e?.date).format("DD/MM/YYYY")}</div>
      ),
      title: <div className="px-2">{e?.title}</div>,
      description: (
        <Tooltip
          color="white"
          arrow={false}
          placement="bottomLeft"
          title={e?.description}
          overlayInnerStyle={{ color: "black" }}
        >
          {e?.description.length > 30
            ? `${e?.description.slice(0, 30)}...`
            : e?.description}
        </Tooltip>
      ),
      vendorSelection: (
        <div className="text-center">{e?.vendorselection?.name}</div>
      ),
      nonvatamount: <div className="text-center">{e?.nonvatamount}</div>,
      vatamount: <div className="text-center">{e?.vatamount}</div>,
      paymentMethod: (
        <div className="text-center">{e?.paymentmethod?.paymentmethod}</div>
      ),
      status: (
        <div className="flex items-center justify-center px-2">
          <Dropdown placement="bottomRight" menu={menuProps}>
            <div
              className={`${
                e?.status
                  ? "text-green bg-green/10"
                  : "text-textyellow bg-bgyellow"
              } w-[90px] text-xs font-normal rounded px-1.5 py-2 flex justify-center items-center gap-1 cursor-pointer`}
            >
              {status}
              <FaAngleDown className="duration-500" />
            </div>
          </Dropdown>
        </div>
      ),
      pendingpayment: (
        <div className="flex items-center justify-center mr-5">
          <MdOutlinePending
            onClick={() => openPendingModal(e)}
            className="text-xl cursor-pointer"
          />
        </div>
      ),
    };
  });

  const fetchMoreData = useCallback(() => {
    if (hasMoreData) {
      setFilter((prev) => ({ ...prev, limit: prev.limit + 10 }));
    }
  }, [hasMoreData]);

  const fetchMoreOptions = useCallback(() => {
    dispatch(
      getPayment({ page: 1, limit: paymentPage, search: searchValue })
    ).then((res) => {
      if (res?.status === 200) {
        setPaymentPage((prev) => prev + 10);
      }
    });
  }, [dispatch, paymentPage, getPaymentData, searchValue]);

  const lastElementRef = useInfiniteScroll(fetchMoreData);

  useEffect(() => {
    dispatch(
      GetPurchase({
        page: filter?.page,
        limit: filter?.limit,
        storeName: searchValue,
        type: filter?.type,
      })
    ).then((res) => {
      if (res.data?.status === 401) {
        navigate("/");
      }
      if (res?.data?.data?.length === 0) {
        setHasMoreData(false);
      }
    });
  }, [dispatch, navigate, filter, searchValue]);

  useEffect(() => {
    dispatch(
      getPayment({
        page: 1,
        limit: 10,
        search: "",
      })
    );
  }, [dispatch]);

  useEffect(() => {
    setPurchasesData(purchaseData);
  }, [purchaseData]);

  return (
    <>
      {bodyData?.length > 0 ? (
        <Table
          tableHeading={headData}
          tableData={bodyData}
          headingClass={"text-left"}
          lastElementRef={lastElementRef}
        />
      ) : (
        <NoData />
      )}
      <Modal
        modalWidth="w-1/3"
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        openModal={openModal}
        closeModal={closeModal}
        imgSrc="/images/approval.svg"
        title="Approval"
        btn1="No I Don’t"
        btn2="Yes I Do"
        btnClass={"justify-end"}
        modalContent={
          <p className="text-lg font-medium">
            Would you like to {selectedSale?.status ? "Pending" : "approve"}{" "}
            this store?
          </p>
        }
        handleBtn2={handleApproval}
      />
      <Modal
        loading={loading}
        modalWidth="w-2/5"
        isOpen={isOpenPending}
        setIsOpen={setIsOpenPending}
        openModal={openPendingModal}
        closeModal={closePendingModal}
        imgSrc="/images/approval.svg"
        title="Approval"
        btn1="No I Don’t"
        btn2="Yes I Do"
        btnClass={"justify-end"}
        modalContent={
          <div className="grid grid-cols-2 gap-5">
            <div>
              <SelectInput
                lableName={"Payment Method"}
                option={paymentOption}
                value={pendingPaymentMethod}
                onChange={(e) => {
                  const value = e.target.value;
                  setPendingPaymentMethod(value);
                  setErrors({ ...errors, pendingPaymentMethod: "" });
                }}
                name={"pendingPaymentMethod"}
                fetchMoreOptions={fetchMoreOptions}
              />
              {errors.pendingPaymentMethod && (
                <div className="text-red-500">
                  {errors.pendingPaymentMethod}
                </div>
              )}
            </div>
            <div>
              <div className="flex flex-col gap-1">
                <label htmlFor="Pending Amount">Pending Payment</label>
                <div className="flex items-center h-[50px] border rounded-[10px] px-3 gap-2">
                  <input
                    className="border-none outline-none flex items-start"
                    type="checkbox"
                    checked
                  />
                  <label htmlFor="checkbox">Pending payment</label>
                </div>
              </div>
            </div>
          </div>
        }
        handleBtn2={handlePendingPayment}
      />
    </>
  );
};

export default PendingTable;
